import { i18nNsFactory } from '@atlas-frontend/i18n';
import { message } from 'antd';
import { FC, PropsWithChildren, useEffect } from 'react';
import { ApiErrorResponse } from '../common/ApiClient';
import { useConfigurationQuery } from './query/useConfigurationQuery';
import { useTranslationOverrides } from '../common/translations/useTranslationOverrides';
import translations from './ConfigurationProvider.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'configuration-provider',
);
addTranslations(translations);

export const ConfigurationProvider: FC<PropsWithChildren> = (props) => {
  const { data } = useConfigurationQuery();
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { error, isFetched: areTranslationOverridesFetched } =
    useTranslationOverrides();

  useEffect(() => {
    if (error) {
      const errors = (error as ApiErrorResponse)?.response?.data.errors ?? [];
      errors.forEach((error) => {
        void messageApi.error(t(`alert.error.code.${error.code}`));
      });
    }
  }, [messageApi, t, error]);

  return (
    <>
      {contextHolder}
      {data && areTranslationOverridesFetched ? props.children : null}
    </>
  );
};
